import { render, staticRenderFns } from "./Deals.vue?vue&type=template&id=3e253a54&scoped=true&lang=pug"
import script from "./Deals.vue?vue&type=script&lang=js"
export * from "./Deals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e253a54",
  null
  
)

export default component.exports